import type { graphql } from 'src/graphql';
import { LANGUAGES } from 'src/i18n';

import type { LanguageLocale } from 'containers/Studies/types/recruit';

export type Locale = ReturnType<typeof graphql.scalar<'Locale'>>;

export const LocaleMap: {
  [key in Locale]: key;
} = {
  ar: 'ar',
  cs: 'cs',
  da: 'da',
  de: 'de',
  en: 'en',
  es: 'es',
  fr: 'fr',
  hi: 'hi',
  hu: 'hu',
  it: 'it',
  ja: 'ja',
  ko: 'ko',
  nl: 'nl',
  pt: 'pt',
  sk: 'sk',
  tr: 'tr',
  zh_CN: 'zh_CN',
  zh_HK: 'zh_HK',
};

const allLocaleOptions = Object.values(LocaleMap) as LanguageLocale[];

// Cantonese (zh_HK) has no AI-moderated TTS voice yet, so it can't be an AI-mod study language.
export const AI_MOD_UNSUPPORTED_LOCALES: LanguageLocale[] = ['zh_HK'];

export const filterAiModLocaleOptions = (options: LanguageLocale[]): LanguageLocale[] =>
  options.filter(locale => !AI_MOD_UNSUPPORTED_LOCALES.includes(locale));

export function useLocale() {
  return {
    availableLanguages: LANGUAGES,
    availableLocaleOptions: allLocaleOptions,
  };
}
